import React from 'react';

import styles from '../../../../styles/sass/components/Header.module.scss';

interface Props {
  title: string;
  slug: string;
  subTitle: string;
}

export default class ToolsHeader extends React.Component<Props> {
  render() {
    const { title, slug, subTitle } = this.props;
    return (
      <div style={{ marginBottom: 25, width: '100%' }}>
        <div className={`${styles.headerContainer} header-container`}>
          <h1 className={`${styles.toolsTitle} ${slug}`}>{title}</h1>
        </div>
        <h3 className={`${styles.toolsInfo} ${slug}`}>{subTitle}</h3>
      </div>
    );
  }
}
